// Mobile sticky add-to-cart bar (snippets/sticky-atc.liquid).
// Shows once the main add-to-cart button has scrolled up out of view, mirrors the
// selected variant, price and button state, and clicks the main add-to-cart button.
if (!customElements.get('sticky-atc')) {
  customElements.define(
    'sticky-atc',
    class StickyAtc extends HTMLElement {
      connectedCallback() {
        if (this.started) return;
        this.started = true;

        this.form = document.getElementById(this.dataset.form);
        this.mainButton = this.form && this.form.querySelector('[name="add"]');
        // No add-to-cart on this product (e.g. Globo-form custom orders): no bar
        if (!this.mainButton) {
          this.remove();
          return;
        }

        this.label = this.querySelector('.sticky-atc__label');
        this.price = this.querySelector('.sticky-atc__price');
        this.button = this.querySelector('.sticky-atc__button');
        this.button.addEventListener('click', () => this.mainButton.click());
        this.priceSource = document.getElementById(`price-${this.dataset.section}`);
        this.mobile = window.matchMedia('(max-width: 749px)');

        // Out of the product section, so sticky/transformed ancestors can't trap position: fixed
        document.body.appendChild(this);

        this.setLabel(JSON.parse(this.querySelector('[data-sticky-atc-options]').textContent));
        this.syncPrice();
        this.syncButton();

        if (typeof subscribe === 'function') {
          subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            if (event.data && event.data.variant) this.setLabel(event.data.variant.options);
            this.syncPrice();
          });
        }
        if (this.priceSource) {
          new MutationObserver(() => this.syncPrice()).observe(this.priceSource, {
            childList: true,
            subtree: true,
            characterData: true,
          });
        }
        new MutationObserver(() => this.syncButton()).observe(this.mainButton, {
          attributes: true,
          attributeFilter: ['disabled'],
          childList: true,
          subtree: true,
          characterData: true,
        });

        // The observed area runs from the top of the screen down indefinitely, so the
        // button leaves it only by scrolling up past the top, even in a single jump.
        // Hidden before the shopper reaches the button, shown once it is above the screen.
        new IntersectionObserver(
          ([entry]) => {
            this.past = !entry.isIntersecting;
            this.update();
          },
          { rootMargin: '0px 0px 100000px 0px' }
        ).observe(this.mainButton);
        this.mobile.addEventListener('change', () => this.update());
      }

      // "Oak" + '36"L x 8"W' -> "36 x 8, Oak"
      setLabel(options) {
        if (!Array.isArray(options)) return;
        const sizes = [];
        const rest = [];
        options.forEach((value) => {
          const size = String(value).match(/([\d.\/ ]+)"?\s*L?\s*x\s*([\d.\/ ]+)"?\s*W/i);
          if (size) sizes.push(`${size[1].trim()} x ${size[2].trim()}`);
          else if (value && value !== 'Default Title') rest.push(value);
        });
        const text = sizes.concat(rest).join(', ');
        if (text) this.label.textContent = text;
      }

      syncPrice() {
        const box = this.priceSource && this.priceSource.querySelector('.price');
        if (!box) return;
        const current = box.classList.contains('price--on-sale')
          ? box.querySelector('.price__sale .price-item--sale')
          : box.querySelector('.price__regular .price-item--regular');
        if (current && current.textContent.trim()) this.price.textContent = current.textContent.trim();
      }

      syncButton() {
        this.button.disabled = this.mainButton.hasAttribute('disabled');
        const text = this.mainButton.querySelector('span');
        if (text && text.textContent.trim()) this.button.textContent = text.textContent.trim();
      }

      overlayOpen() {
        const body = document.body.classList;
        const lockClasses = ['overflow-hidden-mobile', 'custom-menu-open', 'popup-scroll-hidden', 'led-channel-modal-open'];
        if (lockClasses.some((name) => body.contains(name))) return true;
        // Adding to cart also runs the theme drawer's open(), but Rebuy shows its own cart and the
        // theme's close() never runs, so this class and .active stay behind after that cart closes.
        // A theme drawer that is really open is caught as a dialog below.
        if (body.contains('overflow-hidden') && !document.querySelector('cart-drawer.active')) return true;
        if (window.Rebuy && window.Rebuy.SmartCart && window.Rebuy.SmartCart.visible) return true;
        // Closed ones stay in the page, parked off-screen, hidden or at zero size
        const overlays = '.globo-form-publish-modal, .iwish-drawer-menu, modal-dialog[open], details[open] > .search-modal, [role="dialog"][aria-modal="true"]';
        return [...document.querySelectorAll(overlays)].some((overlay) => {
          const box = overlay.getBoundingClientRect();
          const style = getComputedStyle(overlay);
          return box.width && box.height && box.left < document.documentElement.clientWidth - 1 && box.right > 0 && style.visibility !== 'hidden' && style.opacity !== '0';
        });
      }

      update() {
        const active = this.past && this.mobile.matches;
        const show = active && !this.overlayOpen();
        this.classList.toggle('is-visible', show);
        document.body.classList.toggle('sticky-atc-visible', show);
        if (show) document.body.style.setProperty('--sticky-atc-height', `${this.offsetHeight}px`);

        // Drawers and modals lock scrolling, so poll while the bar is in play to catch them
        if (active && !this.timer) this.timer = setInterval(() => this.update(), 400);
        if (!active && this.timer) {
          clearInterval(this.timer);
          this.timer = null;
        }
      }
    }
  );
}
